import React, { useEffect, useState } from "react";

const ReviewLoanDetails = ({
  isReviewLoanDetailsOpen,
  closeReviewLoanDetails,
  handleToGuarantors,
  handleToApplicationSuccess,
  loanProductName,
  handleReviewBack,
  onCancel,
  loanDetails,
}) => {
  const [amount, setAmount] = useState(0);
  const [interest, setInterest] = useState(0);
  const [duration, setDuration] = useState(0);
  const [totalRepayment, setTotalRepayment] = useState(0);
  const [monthlyRepayment, setMonthlyRepayment] = useState(0);
  const [repaymentInterval, setRepaymentInterval] = useState("Monthly");

  useEffect(() => {
    if (!loanDetails) return;

    setAmount(loanDetails.amount || 0);
    setInterest(loanDetails.interest || 0);
    setDuration(loanDetails.duration || "");
    setRepaymentInterval(loanDetails.repaymentInterval || "Monthly");
    setTotalRepayment(loanDetails.totalRepayment || 0);
    setMonthlyRepayment(loanDetails.monthlyRepayment || 0);
  }, [loanDetails]);

  if (!isReviewLoanDetailsOpen) return null;

  return (
    <div
      className={`${
        isReviewLoanDetailsOpen ? "flex" : "hidden"
      } items-center justify-center fixed inset-0 z-10 bg-black bg-opacity-50 overflow-auto`}
    >
      <div className="relative flex items-center min-h-screen max-w-[100%] h-full md:h-auto">
        <div className="relative bg-white shadow w-[600px] md:w-[750px] h-[75vh] mx-auto p-8 rounded-sm flex flex-col">
          <div className="flex justify-end">
            <button
              onClick={closeReviewLoanDetails}
              className="text-gray-600 hover:text-gray-800 text-2xl"
            >
              ✕
            </button>
          </div>

          <div className="mt-4 flex flex-col flex-grow">
            <h2 className="text-2xl font-bold text-black mb-2">Loan Summary</h2>
            <p className="text-gray-600 mb-8 text-sm">
              Review your loan details before proceeding.
            </p>

            <h3 className="text-base font-semibold text-gray-900 mb-3">
              Repayment Summary
            </h3>

            <div className="bg-[#dcecff] p-6 rounded-sm grid grid-cols-2 gap-y-4 gap-x-6 mb-8 text-[15px]">
              <div className="text-gray-800 font-medium">Loan Product</div>
              <div className="text-gray-900 font-semibold text-right">
                {loanProductName}
              </div>

              <div className="text-gray-800 font-medium">Loan Amount</div>
              <div className="text-gray-900 font-semibold text-right">
                KES {Number(amount).toLocaleString()}
              </div>

              <div className="text-gray-800 font-medium">Loan Interest (%)</div>
              <div className="text-gray-900 font-semibold text-right">
                {interest}%
              </div>

              <div className="text-gray-800 font-medium">Total Repayment</div>
              <div className="text-gray-900 font-semibold text-right">
                KES {Number(totalRepayment).toLocaleString()}({duration})
              </div>

              <div className="text-gray-800 font-medium">Repayments</div>
              <div className="text-gray-900 font-semibold text-right">
                KES {Number(monthlyRepayment).toLocaleString()} / month (
                {repaymentInterval})
              </div>
            </div>

            <div className="flex justify-between border-t border-gray-200 pt-4 mt-[50px]">
              <div className="flex space-x-3">
                <button
                  onClick={handleReviewBack}
                  className="border border-[#074073] text-[#074073] hover:bg-[#f5f9ff] font-medium py-2 px-4 rounded-sm text-sm transition-colors duration-150"
                >
                  Back
                </button>
                <button
                  onClick={onCancel || closeReviewLoanDetails}
                  className="border border-[#074073] text-[#074073] hover:bg-[#f5f9ff] font-medium py-2 px-4 rounded-sm text-sm transition-colors duration-150"
                >
                  Cancel Application
                </button>
              </div>

              {loanProductName === "Flash Loan" ||
              loanProductName === "Emergency Loan" ? (
                <button
                  onClick={handleToApplicationSuccess}
                  className="bg-[#074073] hover:bg-[#052f5a] text-white font-medium py-2 px-5 rounded-sm text-sm transition-colors duration-150 w-56 h-10 whitespace-nowrap"
                >
                  Finish Application
                </button>
              ) : (
                <button
                  onClick={handleToGuarantors}
                  className="bg-[#074073] hover:bg-[#052f5a] text-white font-medium py-2 px-5 rounded-sm text-sm transition-colors duration-150 w-56 h-10 whitespace-nowrap"
                >
                  Proceed to Add Guarantors
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewLoanDetails;
